import { useRecentData, useRecentUpdate } from "@/queries/recent.query";
import { ApiRecentKey, ApiRecentPayload } from "@/types/recents/recents.types";
import { SelectItem } from "@skailer-com/uikit";

export const useRecent = (enabled = true) => {
  const { data } = useRecentData(enabled);
  const recentMutation = useRecentUpdate();

  const getRecentOptions = <T extends SelectItem>(type: ApiRecentKey, options: T[]): T[] => {
    const values = data?.entities.find((item) => item.type === type)?.values ?? [];
    return values
      .map((value) => options.find((option) => option.id === value))
      .filter((option): option is T => Boolean(option));
  };

  const addRecent = (entries: ApiRecentPayload[]) => {
    recentMutation.mutate(entries);
  };

  return { getRecentOptions, addRecent };
};
